/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Trainer_Reply_LabelInputs */

const en_us2_profile_trainer_reply_label = /** @type {(inputs: Profile_Trainer_Reply_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainer replies`)
};

const pt_br2_profile_trainer_reply_label = /** @type {(inputs: Profile_Trainer_Reply_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respostas do personal`)
};

const es_419_profile_trainer_reply_label = /** @type {(inputs: Profile_Trainer_Reply_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respuestas del entrenador`)
};

const pt_pt2_profile_trainer_reply_label = /** @type {(inputs: Profile_Trainer_Reply_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Respostas do treinador`)
};

const fr_fr2_profile_trainer_reply_label = /** @type {(inputs: Profile_Trainer_Reply_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réponses du coach`)
};

const de_de2_profile_trainer_reply_label = /** @type {(inputs: Profile_Trainer_Reply_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antworten vom Coach`)
};

const it_it2_profile_trainer_reply_label = /** @type {(inputs: Profile_Trainer_Reply_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risposte del coach`)
};

/**
* | output |
* | --- |
* | "Trainer replies" |
*
* @param {Profile_Trainer_Reply_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_trainer_reply_label = /** @type {((inputs?: Profile_Trainer_Reply_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Trainer_Reply_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_trainer_reply_label(inputs)
	if (locale === "es-419") return es_419_profile_trainer_reply_label(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_trainer_reply_label(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_trainer_reply_label(inputs)
	if (locale === "de-DE") return de_de2_profile_trainer_reply_label(inputs)
	if (locale === "it-IT") return it_it2_profile_trainer_reply_label(inputs)
	return en_us2_profile_trainer_reply_label(inputs)
});
export { profile_trainer_reply_label as "profile.trainer_reply_label" }